/**
 * @generated SignedSource<<29af0d3d6c2f3a2606e973de59821f05>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateJiraInstanceInput = {
  apiKey?: string | null | undefined;
  clientId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  defaultSpaceKey?: string | null | undefined;
  defaultWorkTypeName?: string | null | undefined;
  issueLimitHard?: number | null | undefined;
  issueLimitSoft?: number | null | undefined;
  name?: string | null | undefined;
  url?: string | null | undefined;
  username?: string | null | undefined;
  uuid: any;
};
export type UpdateJiraInstanceMutation$variables = {
  input: UpdateJiraInstanceInput;
};
export type UpdateJiraInstanceMutation$data = {
  readonly updateJiraInstance: {
    readonly jiraInstance: {
      readonly clientId: string | null | undefined;
      readonly defaultSpace: {
        readonly key: string;
        readonly name: string;
      } | null | undefined;
      readonly defaultWorkType: {
        readonly name: string;
      } | null | undefined;
      readonly error: string | null | undefined;
      readonly id: string;
      readonly issueLimitHard: number;
      readonly issueLimitSoft: number;
      readonly name: string | null | undefined;
      readonly spaces: ReadonlyArray<{
        readonly key: string;
        readonly name: string;
        readonly workTypes: ReadonlyArray<{
          readonly iconUrl: string;
          readonly name: string;
        }>;
      }>;
      readonly spacesUpdated: string | null | undefined;
      readonly updatePending: boolean;
      readonly url: string;
      readonly username: string | null | undefined;
      readonly uuid: any;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type UpdateJiraInstanceMutation = {
  response: UpdateJiraInstanceMutation$data;
  variables: UpdateJiraInstanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraInstance",
  "kind": "LinkedField",
  "name": "jiraInstance",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraSpace",
      "kind": "LinkedField",
      "name": "defaultSpace",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        (v3/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraWorkType",
      "kind": "LinkedField",
      "name": "defaultWorkType",
      "plural": false,
      "selections": [
        (v3/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "error",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueLimitHard",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueLimitSoft",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraSpace",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraWorkType",
          "kind": "LinkedField",
          "name": "workTypes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "iconUrl",
              "storageKey": null
            },
            (v3/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spacesUpdated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatePending",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateJiraInstancePayload",
        "kind": "LinkedField",
        "name": "updateJiraInstance",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateJiraInstancePayload",
        "kind": "LinkedField",
        "name": "updateJiraInstance",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6bde3e3190f5212bc81d02894850b8b1",
    "id": null,
    "metadata": {},
    "name": "UpdateJiraInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateJiraInstanceMutation(\n  $input: UpdateJiraInstanceInput!\n) {\n  updateJiraInstance(input: $input) {\n    jiraInstance {\n      clientId\n      defaultSpace {\n        key\n        name\n      }\n      defaultWorkType {\n        name\n      }\n      error\n      id\n      issueLimitHard\n      issueLimitSoft\n      name\n      spaces {\n        key\n        name\n        workTypes {\n          iconUrl\n          name\n        }\n      }\n      spacesUpdated\n      updatePending\n      url\n      username\n      uuid\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "424a9b774d015f594da40d1a1831e001";

export default node;
